import React from 'react';

import dayjs, { Dayjs } from 'dayjs';
import { Button } from '../../button';
import { SELECT_VIEW } from './constant';

interface Props {
  onSelectMonth: (data: number) => void;
  setActiveSelectView?: (data: string) => void;
  displayDate: Dayjs;
  onClickMonth?: (data: number) => void;
  setIsOpen?: (data: boolean) => void;
  isMonthPicker?: boolean;
}

const PopulateMonths = ({
  onSelectMonth,
  setActiveSelectView,
  displayDate,
  onClickMonth,
  setIsOpen,
  isMonthPicker,
}: Props) => {
  const displayMonth = displayDate.get('month');

  return (
    <div className="d-flex justify-content-between align-items-start">
      <div className="d-flex flex-wrap gap-4 px-8">
        {Array(12)
          .fill(0)
          .map((_item, index) => (
            <Button
              className="p-4"
              type={displayMonth === index ? 'primary' : 'default'}
              key={index}
              onClick={() => {
                onSelectMonth(index);
                onClickMonth && onClickMonth(index + 1);
                isMonthPicker && setIsOpen && setIsOpen(false);
              }}
            >
              {dayjs().month(index).format('MMMM')}
            </Button>
          ))}
      </div>
      {setActiveSelectView ? (
        <Button
          type="danger"
          onClick={() => setActiveSelectView(SELECT_VIEW.DATE)}
        >
          Close
        </Button>
      ) : null}
    </div>
  );
};

export default PopulateMonths;
